<template>
  <div class="sobre">
    <SingleMain v-for="(item, index) in sobre" :key="index"
    :imgFull='item.imgFull'
    :imgLarge='item.imgLarge'
    :imgMedium='item.imgMedium'
    :imgSmall='item.imgSmall'
    :title='item.title'
    :text='item.text'
    :alt='item.title'/>
  </div>
</template>

<script>
import { apis } from '@/api.js'
import SingleMain from '@/templates/_SingleMain'

export default {
  name: 'Sobre',
  components: {
    SingleMain
  },
  data () {
    return {
      url: apis.api.sobreAPI,
      sobre: ''
    }
  },
  methods: {
    getApi () {
      fetch(this.url)
        .then(response => response.json())
        .then(response => {
          this.sobre = response
        })
    }
  },
  created () {
    this.getApi()
  }
}
</script>

<style>

</style>
